// angular
// 	.module("HeroPRO")
// 	.controller("actionItemFiltersController", actionItemFiltersController);

import './actionItemFilters.scss';

/* @ngInject */
export default function actionItemFiltersController(actionItemFiltersFactory, $timeout, $analytics, $scope, $rootScope) {
    const vm = this;
    vm.filtersOpen = false;
    vm.labelOptions = [];
    vm.statusOptions = [];
    vm.activeLabel = {};
    vm.activeStatus = {};

    init();

    /*= =======================================
	=            Public Functions            =
    ======================================== */
    vm.toggleFilters = function () {
    // The timeout is needed so that any open filter dropdowns close before the filters section collapses
        $timeout(() => {
            vm.filtersOpen = !vm.filtersOpen;
        });
    };

    vm.statusFilterChange = function (newStatus) {
        vm.activeStatus = newStatus;
    	actionItemFiltersFactory.setActionItemFilter('ActionItemStatuses', vm.activeStatus.ActionItemStatusId);
    	$analytics.eventTrack('Status Filter', { category: 'ActionItem', label: vm.activeStatus.ActionItemStatusName });
    };

    vm.labelFilterChange = function (newLabel) {
    	vm.activeLabel = newLabel;
    	actionItemFiltersFactory.setActionItemFilter('ActionItemLabels', vm.activeLabel.ActionItemLabelId);
    	$analytics.eventTrack('Label Filter', { category: 'ActionItem', label: vm.activeLabel.ActionItemLabelDescription });
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
	=            Private Functions            =
    ======================================== */
    function init() {
    	resetFilters();

    	// Retrieve all the action item filter options
    	actionItemFiltersFactory.getActionItemFilterOptions().then((response) => {
    		vm.labelOptions = response.ActionItemLabels;
    		vm.statusOptions = response.ActionItemStatuses;
    	});

    	// Reset action item filters when the location dropdown is changed
        $scope.$on('HPLocationChange', () => {
            resetFilters();
        });

        // When leaving the todo state reset the action item filters
        var stateChangeListener = $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState) => {
            if (fromState.name === 'todo') {
                actionItemFiltersFactory.resetFilters();
                stateChangeListener(); // Unregister the existing listener
            }
        });
    }

    function resetFilters() {
        vm.filtersOpen = false;
        vm.activeLabel = { ActionItemLabelId: 0, ActionItemLabelDescription: 'All' };
        vm.activeStatus = { ActionItemStatusId: 1, ActionItemStatusName: 'Open' };
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/actionItems/actionItemFiltersController.js